export enum ThemeType {
    light = 'light',
    dark = 'dark',
    night = 'night',
    darkOriginal = 'dark-original',
}

export function isDark(themeType: ThemeType) {
    return (
        themeType === ThemeType.dark ||
        themeType === ThemeType.night ||
        themeType === ThemeType.darkOriginal
    );
}
